import { STATUS_OPTION } from "../../constants/Constant";
import TimesheetService from "./TimesheetService";

export const PAGE_VIEW = {
    CALENDAR: "Calendar",
    LIST: "List"
};

export const CALENDAR_VIEW = {
    DAY: "Day",
    WEEK: "Week",
    MONTH: "Month"
};

export const CALENDAR_VIEW_OPTIONS = ["Day", "Week", "Month"];

export const ENTRY_MODE = {
    TIMER: "Timer",
    MANUAL: "Manual"
}

export const ENTRY_STATUS = {
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED"
}



export const MAPPING_COLUMNS = [
    {
        type: "text",
        name: "Employee",
        key: "employeeId",
        columnCode: "employeeId",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 200,
        allowFilter: false
    },
    {
        type: "select",
        name: "Customer",
        key: "customer",
        columnCode: "customer",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 150,
        allowFilter: false,
        options: TimesheetService.CUSTOMERS.map((c) => {
            return { id: c.value, name: c.label };
        })
    },
    {
        type: "select",
        name: "Project",
        key: "projectId",
        columnCode: "projectId",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 200,
        allowFilter: false,
        options: TimesheetService.PROJECTS_DATA.map((p) => {
            return { id: p.id, name: p.name };
        })
    },
    {
        type: "number",
        name: "Rate Per Hour",
        key: "ratePerHour",
        columnCode: "ratePerHour",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 150,
        allowFilter: false
    }
];

export const ADMIN_TIMESHEET_REPORT_COLUMNS = [
    {
        type: "text",
        name: "Employee Name",
        key: "employeeName",
        columnCode: "employeeName",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 200,
        allowFilter: false
    },
    {
        type: "text",
        name: "Total Hrs",
        key: "totalHrs",
        columnCode: "totalHrs",
        editable: false,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 150,
        allowFilter: false
    }
];
